/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface CarouselContext {
    direction?: string;
}

// Create a context wrapping some shared state
export default React.createContext<CarouselContext>({
    direction: 'right'
});
